import { useState } from 'react'
import InvestorPortalLayout from '@/layouts/InvestorPortalLayout'

interface InvestorRecord {
  id: number
  name: string
  lender_business_name: string
}

interface Props {
  investors: InvestorRecord[]
  available_years: number[]
}

export default function Statements({ investors, available_years }: Props) {
  const defaultYear = available_years[1] ?? available_years[0]
  const [year, setYear] = useState<number>(defaultYear)

  function handleDownload(investorId: number) {
    window.location.href = `/investor-portal/statements/${investorId}/download.pdf?year=${year}`
  }

  return (
    <InvestorPortalLayout>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Year-End Statements</h1>
        <p className="text-sm text-gray-500 mt-1">
          Download annual statements covering your loan participations and distributions for tax filing.
        </p>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-5 mb-6">
        <label className="block text-xs text-gray-500 mb-1">Tax year</label>
        <select
          value={year}
          onChange={(e) => setYear(Number(e.target.value))}
          className="text-sm px-3 py-2 border border-gray-200 rounded-lg bg-white text-gray-700"
        >
          {available_years.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>

      {investors.length === 0 ? (
        <div className="bg-white rounded-xl border border-gray-200 p-10 text-center">
          <p className="text-sm text-gray-500">
            No investor accounts are linked yet. Contact your lender if you expected to see statements here.
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {investors.map((investor) => (
            <div key={investor.id} className="bg-white rounded-xl border border-gray-200 p-5 flex items-center justify-between gap-4 flex-wrap">
              <div>
                <h3 className="text-sm font-semibold text-gray-900">{investor.name}</h3>
                <p className="text-xs text-gray-500 mt-0.5">via {investor.lender_business_name}</p>
              </div>
              <button
                type="button"
                onClick={() => handleDownload(investor.id)}
                className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold rounded-lg transition-colors"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4" />
                </svg>
                Download {year} statement
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="mt-8 rounded-lg bg-amber-50 border border-amber-100 px-4 py-3">
        <p className="text-xs text-amber-700">
          Informational only. LendSolo is a tracking tool, not a tax advisor. Consult your accountant.
        </p>
      </div>
    </InvestorPortalLayout>
  )
}
